"use client"

import { usePathname, useRouter, useSearchParams } from "next/navigation"
import { useCallback } from "react"
import { SortOptions } from "./sort-products"

type RefinementListProps = {
  sortBy: SortOptions
  search?: boolean
  'data-testid'?: string
}

const sortOptions: { value: SortOptions; label: string }[] = [
  { value: "created_at", label: "Latest Arrivals" },
  { value: "price_asc", label: "Price: Low → High" },
  { value: "price_desc", label: "Price: High → Low" },
  { value: "title_asc", label: "Name A-Z" },
]

const RefinementList = ({ sortBy, 'data-testid': dataTestId }: RefinementListProps) => {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const currentSort = (searchParams.get("sortBy") as SortOptions) || sortBy

  const setSort = useCallback(
    (value: SortOptions) => {
      const params = new URLSearchParams(searchParams)
      params.set("sortBy", value)
      router.push(`${pathname}?${params.toString()}`)
    },
    [router, pathname, searchParams]
  )

  return (
    <div
      className="flex small:flex-col gap-2 py-4 mb-8 small:px-0 pl-6 small:min-w-[200px] small:ml-[1.675rem]"
      data-testid={dataTestId}
    >
      <p className="txt-compact-small-plus text-ui-fg-muted text-sm font-semibold text-gray-500 uppercase tracking-wider mb-1">
        Sort by
      </p>
      {sortOptions.map((option) => (
        <button
          key={option.value}
          onClick={() => setSort(option.value)}
          className={`text-sm text-left py-1.5 px-2 rounded transition-colors ${
            currentSort === option.value
              ? "bg-gray-100 text-gray-900 font-medium"
              : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}

export default RefinementList
